import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { TGetMainArticlesAppendSucceed, EGetMainArticlesActionType } from './types';
import { IArticlesMainDataSchema } from '../../../repositories/journal/entities/journal/ArticlesMainDataSchema';

export const getMainArticlesAppendSucceed: (articles: IArticlesMainDataSchema[]) => TGetMainArticlesAppendSucceed =
  actionGenerator<EGetMainArticlesActionType.AppendSucceed, IArticlesMainDataSchema[]>(
    EGetMainArticlesActionType.AppendSucceed,
  );
